import React, {useState, useEffect} from 'react';
import 'fontsource-roboto';
import {makeStyles} from '@material-ui/core/styles';
import useIsMountedRef from '../Components/useIsMountedRef';
import useForceUpdate from '../Components/useForceUpdate';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import Warning from '../Components/Warning';

const useStyles = makeStyles(theme => ({
  divider: {
    margin: theme.spacing(.5, 0)
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: theme.spacing(1, 0)
  },
  cardContent: {
    flexGrow: 1,
    padding: theme.spacing(1),
    '&:last-child': {
      paddingBottom: theme.spacing(1)
    }
  },
  link: {
    textDecoration: 'initial',
    color: 'inherit',
    '&:active': {
      color: 'inherit'
    }
  },
  listItemDense: {
    paddingTop: '0px',
    paddingBottom: '0px'
  },
  listItemIcon: {
    minWidth: theme.spacing(5)
  },
  listItemTextDense: {
    marginTop: '0px',
    marginBottom: '0px'
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  },
  fabIcon: {
    marginRight: theme.spacing(1)
  }
}));

const defaultFields = [
  {label: 'ID'                      , name: 'id'                                       , checkedIndex: null, isIgnored: true , value: '', description: 'Se selecteaza automat ID-ul de persoana care nu a fost accesat de cel mai mult timp'},
  {label: 'Nume'                    , name: 'name'                                     , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'CNP'                     , name: 'cnp'                                      , checkedIndex: null, isIgnored: true , value: '', description: 'Se selecteaza automat'},
  {label: 'Sex'                     , name: 'sex'                                      , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'Data nasterii'           , name: 'birthDate'                                , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'ID card'                 , name: 'cardId'                                   , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'Card expira'             , name: 'card_expire'                              , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'Date contact'            , name: 'contactData'                              , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'Telefon'                 , name: 'telefon'                                  , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'Email'                   , name: 'email'                                    , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'Companie'                , name: 'company'            , id: 'companyId'     , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'Data inregistrarii'      , name: 'registrationDate'                         , checkedIndex: null, isIgnored: true , value: '', description: 'Se selecteaza automat data corespondenta persoanei care nu a fost accesata de cel mai mult timp'},
  {label: 'Data ultimei analize'    , name: 'lastAnalysisDate'                         , checkedIndex: null, isIgnored: true , value: '', description: 'Nu se selecteaza nici o valoare, se calculeaza in mod automat'},
  {label: 'Discount'                , name: 'discount'                                 , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'Grupa sanguina'          , name: 'bloodGroup'                               , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'Tip sanguin'             , name: 'bloodType'                                , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'Localitate'              , name: 'locality'                                 , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'Judet'                   , name: 'county'                                   , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'Cod judet'               , name: 'countryCode'                              , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'Greutate'                , name: 'weight'                                   , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'Data cantaririi'         , name: 'dateOfWeight'                             , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'Sters'                   , name: 'deleted'                                  , checkedIndex: null, isIgnored: true , value: '', description: 'Nu se selecteaza nici o valoare, se calculeaza in mod automat'},
  {label: 'Ultima actiune'          , name: 'dateOf'                                   , checkedIndex: null, isIgnored: true , value: '', description: 'Nu se selecteaza nici o valoare, se calculeaza in mod automat'},
  {label: 'Adaugat de'              , name: 'user'               , id: 'userId'        , checkedIndex: null, isIgnored: true , value: '', description: 'Se selecteaza automat data corespondenta persoanei care nu a fost accesata de cel mai mult timp'},
  {label: 'Tip persoana'            , name: 'personType'         , id: 'personType_id' , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'Unitatea emitenta'       , name: 'emissiveUnit'                             , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'Stare persoana'          , name: 'personState'        , id: 'personState_id', checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'Pachet servicii medicale', name: 'medSrvPack'         , id: 'medSrvPack_id' , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'Exportat la'             , name: 'dateTimeOfExport'                         , checkedIndex: null, isIgnored: true , value: '', description: 'Nu se selecteaza nici o valoare, se calculeaza in mod automat'},
  {label: 'Din mediu urban'         , name: 'urban'                                    , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'PIH'                     , name: 'pih'                                      , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'CID'                     , name: 'cid'                                      , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'Numar card'              , name: 'cardNo'                                   , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'Data certificatului'     , name: 'certificateDate'                          , checkedIndex: null, isIgnored: false, value: '', description: ''},
  {label: 'Data acord GDPR'         , name: 'dateOfGdprAllowance'                      , checkedIndex: null, isIgnored: true, value: '', description: 'Nu se selecteaza nici o valoare, se calculeaza in mod automat'}
];

export default function CnpDuplicates(props) {
  const classes = useStyles();
  const ajax = props.ajax;

  const isMountedRef = useIsMountedRef();
  const forceUpdate = useForceUpdate();

  const [isLoaded, setIsLoaded] = useState(false);
  const [filter, setFilter] = useState({cnp: ''});
  const [data, setData] = useState([]);
  const [fields, setFields] = useState(defaultFields);

  useEffect(() => {
    setIsLoaded(false);
    ajax('slGetCnpDuplicates')
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          setData(response.data);

        setIsLoaded(true);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFilterChange = e => {
    if (e.target.name === 'cnp') {
      setIsLoaded(false);
      ajax('slGetCnpDuplicatePersons', {
        cnp: e.target.value
      })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          setData(response.data);

        setIsLoaded(true);
      });
    }

    setFilter({
      ...filter,
      [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value !== null ? e.target.value : ''
    });
  };

  useEffect(() => {
    if (!data.persons || filter.cnp === '')
      return;

    var tmpFields = defaultFields;
    for (let i = 0; i < tmpFields.length; i++) {
      if (tmpFields[i].isIgnored) {
        switch (tmpFields[i].name) {
          case 'id':
            tmpFields[i].checkedIndex = 0;
            tmpFields[i].value = data.persons[0].id;
            break;
          case 'cnp':
            tmpFields[i].checkedIndex = 0;
            tmpFields[i].value = filter.cnp;
            break;
          case 'registrationDate':
            tmpFields[i].checkedIndex = 0;
            tmpFields[i].value = data.persons[0].registrationDate;
            break;
          case 'lastAnalysisDate':
            tmpFields[i].value = data.cnpDuplicates.filter(cnp => cnp.cnp === filter.cnp)[0].lastAnalysisDate;
            break;
          case 'deleted':
            tmpFields[i].value = '0';
            break;
          case 'dateOf':
            tmpFields[i].value = data.cnpDuplicates.filter(cnp => cnp.cnp === filter.cnp)[0].lastDateOf;
            break;
          case 'user':
            tmpFields[i].checkedIndex = 0;
            tmpFields[i].value = data.persons[0].user;
            break;
          case 'dateTimeOfExport':
            tmpFields[i].value = null;
            break;
          case 'dateOfGdprAllowance':
            tmpFields[i].value = data.cnpDuplicates.filter(cnp => cnp.cnp === filter.cnp)[0].dateOfGdprAllowance;
            break;

          default:
            break;
        }

        continue;
      }

      // completeaza tmpFields[i].checkedIndex si tmpFields[i].value
      for (let j = data.persons.length - 1; j >= 0 ; j--) {
        if (data.persons[j][tmpFields[i].name] !== null && data.persons[j][tmpFields[i].name] !== '') {
          tmpFields[i].checkedIndex = j;
          tmpFields[i].value = data.persons[j][tmpFields[i].name];
          break;
        }
      }
    }
    setFields(tmpFields);
  }, [data, filter.cnp]);

  const checkboxIsDisabled = (field, item, i) => {
    if (field.isIgnored || item[field.name] === null || item[field.name] === '' || data.persons[i].deleted === '1')
      return true;

    if (i < data.persons.length - 1)
      for (let index = data.persons.length - 1; index > i; index--)
        if (item[field.name] === data.persons[index][field.name])
          return true;

    return false;
  };

  const handleFieldValueChange = index => e => {
    if (!e.target.checked)
      return;

    let tmpFields = fields;
    for (let i = 0; i < tmpFields.length; i++) {
      if (tmpFields[i].name === e.target.name) {
        tmpFields[i].checkedIndex = index;
        tmpFields[i].value = data.persons[index][e.target.name];
        break;
      }
    }
    setFields(tmpFields);
    forceUpdate();
  };

  const getFieldDetails = name => fields.filter(field => field.name === name)[0];

  const getValueFromFieldName = name => getFieldDetails(name).checkedIndex === null ? null : data.persons[getFieldDetails(name).checkedIndex][getFieldDetails(name).id ? getFieldDetails(name).id : name];

  const handleSavePerson = () => {
    setIsLoaded(false);
    ajax('slRemoveDuplicateCnpPersons', {
      id: getValueFromFieldName('id'),
      name: getValueFromFieldName('name'),
      cnp: filter.cnp,
      sex: getValueFromFieldName('sex'),
      birthDate: getValueFromFieldName('birthDate'),
      cardId: getValueFromFieldName('cardId'),
      card_expire: getValueFromFieldName('card_expire'),
      contactData: getValueFromFieldName('contactData'),
      telefon: getValueFromFieldName('telefon'),
      email: getValueFromFieldName('email'),
      companyId: getValueFromFieldName('company'),
      registrationDate: getValueFromFieldName('registrationDate'),
      lastAnalysisDate: getValueFromFieldName('lastAnalysisDate'),
      discount: getValueFromFieldName('discount'),
      bloodGroup: getValueFromFieldName('bloodGroup'),
      bloodType: getValueFromFieldName('bloodType'),
      locality: getValueFromFieldName('locality'),
      county: getValueFromFieldName('county'),
      countryCode: getValueFromFieldName('countryCode'),
      weight: getValueFromFieldName('weight'),
      dateOfWeight: getValueFromFieldName('dateOfWeight'),
      deleted: '0',
      dateOf: getValueFromFieldName('dateOf'),
      userId: getValueFromFieldName('user'),
      personType_id: getValueFromFieldName('personType'),
      emissiveUnit: getValueFromFieldName('emissiveUnit'),
      personState_id: getValueFromFieldName('personState'),
      medSrvPack_id: getValueFromFieldName('medSrvPack'),
      dateTimeOfExport: null,
      urban: getValueFromFieldName('urban'),
      pih: getValueFromFieldName('pih'),
      cid: getValueFromFieldName('cid'),
      cardNo: getValueFromFieldName('cardNo'),
      certificateDate: getValueFromFieldName('certificateDate'),
      dateOfGdprAllowance: getValueFromFieldName('dateOfGdprAllowance'),
      idOfCnpDuplicates: data.persons.map(person => person.id).slice(1)
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          setFilter({cnp: ''})
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  return (
    <Container maxWidth='lg'>
      <Typography variant='h6'>Mentenanta persoane SmartLabs</Typography>
      <Typography variant='subtitle2'>Administrare persoane salvate de mai multe ori in SmartLabs.</Typography>
      <Typography variant='subtitle2'>* Persoanele care sunt marcate ca sterse in SmartLabs au campurile in culoarea rosie.</Typography>
      <Divider className={classes.divider} />

      {!isLoaded &&
        <Box display='block' align='center'>
          <CircularProgress />
        </Box>
      }

      {isLoaded && data.cnpDuplicates.length === 0 &&
        <Warning variant='subtitle2' align='center'>Nu exista nici o persoana cu CNP-uri duplicate.</Warning>
      }

      {isLoaded && data.cnpDuplicates.length > 0 &&
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField margin='none' select
              label='Selectati un CNP din lista'
              placeholder='Selectati un CNP din lista'
              name='cnp'
              value={filter.cnp}
              onChange={handleFilterChange}
            >
              {data.cnpDuplicates.map(option => (
                <MenuItem key={option.cnp} value={option.cnp}>
                  <Typography component='div'>{option.cnp}<Typography color='textSecondary' display='inline'> ({option.cnpCount} inregistrari)</Typography></Typography>
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
      }

      {isLoaded && Boolean(data.persons) && data.persons.length > 0 &&
        <Box>
          <List dense>
            {fields.map(field =>
              <ListItem key={field.name} dense className={classes.listItemDense}>
                <ListItemText
                  primary={
                    <Grid container>
                      <Grid item xs={2} style={{marginTop: 'auto', marginBottom: 'auto'}}>
                        <Typography color={field.isIgnored ? 'textSecondary' : 'textPrimary'}>{field.label}:</Typography>
                      </Grid>
                      {data.persons.map((item, i) =>
                        <Grid item key={item.id} xs={parseInt(10 / data.persons.length)}>
                          <FormControlLabel style={{marginLeft: '0px', marginRight: '0px'}}
                            control={
                              <Checkbox size='small' disableRipple edge='start' color='primary'
                                disabled={checkboxIsDisabled(field, item, i)}
                                checked={field.checkedIndex === i}
                                name={field.name}
                                onChange={handleFieldValueChange(i)}
                              />
                            }
                            label={
                              <Typography color={item.deleted === '1' ? 'secondary' : 'inherit'}>
                                {Boolean(field.id) ? `${item[field.id] ? item[field.id] : ''}${item[field.name] ? ` (${item[field.name]})` : ''}` : item[field.name]}
                              </Typography>
                            }
                          />
                        </Grid>
                      )}
                    </Grid>
                  }
                  secondary={<Typography variant='caption' color='secondary'>{field.description}</Typography>}
                />
              </ListItem>
            )}
          </List>
          <DialogActions>
            <Button disabled={!isLoaded} onClick={() => {
              setFilter({cnp: ''});
              setData({cnpDuplicates: data.cnpDuplicates})
            }}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded} color='primary' onClick={handleSavePerson}>
              Salveaza
            </Button>
          </DialogActions>
        </Box>
      }
    </Container>
  );
}